/*** IMPORTS FROM imports-loader ***/
import "core-js/modules/es.promise";
import "core-js/modules/es.array.iterator";

$(async function () {
	// Responsive menu	
	$('.toggler, .main-navigation a').click(function () {
		var toggler = $('.toggler');
		var responsiveNav = $('.responsive-nav');

		$(document.body).toggleClass('menu-open');
		responsiveNav.toggleClass('-collapsed');
		toggler.toggleClass('is-active');
	});

	// Responsive table
	$('table').wrap('<div class="table-wrapper">');

	// Slider
	$('.welcome-hero .swiper-container').each(async function () {
		const Swiper = (await import('swiper/dist/js/swiper.js')).default;

		new Swiper(this, {
			grabCursor: true,
			loop: true,
			effect: 'fade',
			slidesPerView: 1,
			autoplay: {
				delay: 3000
			},
			speed: 1500
		});
	});

	// Lightbox
	var lightbox;
	$('body:has([rel=lightbox])').each(async function () {
		await import('lightgallery');

		lightbox = $(this).lightGallery({
			selector: '[rel=lightbox]',
			download: false,
			thumbnail: false,
			fullScreen: false,
			actualSize: false,
			hash: false
		});
	});

	// Paged images
	var imageGallery = $('.gallery');
	if (imageGallery.length) {
		await import(/* webpackChunkName: "waypoints" */ 'waypoints/lib/jquery.waypoints.js');
		await import(/* webpackChunkName: "waypoints" */ 'waypoints/lib/shortcuts/infinite.js');

		imageGallery.each(function () {
			var images = $(this);

			images.find('a[rel=next]').one('click', function (e) {
				new Waypoint.Infinite({
					element: images[0],
					container: images.find('.row'),
					items: '.col-s-6',
					more: 'a[rel=next]',
					offset: function () {
						return Waypoint.offsetAliases['bottom-in-view'].call(this) + 200;
					},
					onAfterPageLoad: function (items) {
						// Fade in added items
						const delay = 40;
						items.css('opacity', 0).each(function (i) {
							var item = $(this);
							setTimeout(function () {
								item.css({
									opacity: 1,
									transition: 'opacity ease 120ms'
								});
							}, i * delay);
						});

						$('body:has([rel=lightbox])').each(async function () {
							await import('lightgallery');

							if (lightbox) {
								lightbox.data('lightGallery').destroy(true);
							}

							lightbox = $(this).lightGallery({
								selector: '[rel=lightbox]',
								download: false,
								thumbnail: false,
								fullScreen: false,
								actualSize: false,
								hash: false
							});
						});
					}
				});

				images.find('.pagination-container').hide();
				e.preventDefault();
			});
		});
	}

	// Google Maps 
	$('.google-maps').each(async function () {
		var maps = $(this);
		var apiKey = maps.data('api-key');
		var locations = maps.data('locations');

		const loadGoogleMapsApi = (await import('load-google-maps-api')).default;
		const googleMaps = await loadGoogleMapsApi({
			key: apiKey
		});

		var map = new googleMaps.Map(maps[0], {
			zoom: 13,
			zoomControl: true,
			mapTypeControl: true,
			scaleControl: true,
			streetViewControl: true,
			rotateControl: false,
			fullscreenControl: true,
			backgroundColor: 'none',
			styles: [{ "featureType": "all", "elementType": "labels.text.fill", "stylers": [{ "saturation": 36 }, { "color": "#000000" }, { "lightness": 40 }] }, { "featureType": "all", "elementType": "labels.text.stroke", "stylers": [{ "visibility": "on" }, { "color": "#000000" }, { "lightness": 16 }] }, { "featureType": "all", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#000000" }, { "lightness": 20 }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#000000" }, { "lightness": 17 }, { "weight": 1.2 }] }, { "featureType": "administrative", "elementType": "labels", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative.country", "elementType": "all", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "administrative.country", "elementType": "geometry", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "administrative.country", "elementType": "labels.text", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "administrative.province", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative.locality", "elementType": "all", "stylers": [{ "visibility": "simplified" }, { "saturation": "-100" }, { "lightness": "30" }] }, { "featureType": "administrative.neighborhood", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative.land_parcel", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "landscape", "elementType": "all", "stylers": [{ "visibility": "simplified" }, { "gamma": "0.00" }, { "lightness": "74" }] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 20 }] }, { "featureType": "landscape.man_made", "elementType": "all", "stylers": [{ "lightness": "3" }] }, { "featureType": "poi", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 21 }] }, { "featureType": "road", "elementType": "geometry", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#000000" }, { "lightness": 17 }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#000000" }, { "lightness": 29 }, { "weight": 0.2 }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 18 }] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 16 }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 19 }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 17 }] }]
		});

		var markers = [];
		var bounds = new google.maps.LatLngBounds();

		$.each(locations, function (i, location) {
			var pointer = '/images/pointer-s-gravenzande.png';
			if (location.name === 'De Lier') {
				pointer = '/images/pointer-de-lier.png';
			}

			var marker = new google.maps.Marker({
				position: location.position,
				map: map,
				icon: {
					url: pointer,
					scaledSize: new google.maps.Size(153, 94),
					origin: new google.maps.Point(0, 0),
					anchor: new google.maps.Point(76, 90)
				}
			});

			markers.push(marker);
			bounds.extend(marker.position);
		});

		map.fitBounds(bounds);
	});

	// Jump to submitted form
	$('.form:has(form)').each(function () {
		var $this = $(this),
			$form = $this.find('form'),
			anchor = $this.find('.anchor').attr('name'),
			button = $this.find('.button');

		if (anchor === undefined) {
			anchor = $this.attr('id');
		}

		$form.attr('action', $form.attr('action') + '#' + anchor);

		$form.on('submit', function () {
			button.addClass('is-loading');
		});
	});

	// Reservation forms
	$('.form-reserveringsaanvraageetcafédewittesgravenzande, .form-reserveringsaanvraageetcafédewittedelier').each(function () {
		var element = $(this),
			dropdown = element.find(".waarkomjevoor select"),
			number = element.find(".aantalpersonen input");

		function changePersonMin() {
			if (dropdown.val() === "Diner (min. 8 personen)") {
				number.attr({
					'min': 8
				});
			}
			else {
				number.attr({
					'min': 2
				});
			}
		}

		dropdown.on('change', function () {
			changePersonMin();
		});

		changePersonMin();
	});

	var homeId = document.body.getAttribute('data-home-id');
	if (homeId !== null) {
		fetch('/umbraco/api/Toaster/GetToastr?pageId=' + homeId).then(response => response.json()).then(async json => {
			if (!json || !json.id) return;

			var toastr = (await import('toastr')).default;
			var Cookies = (await import('js-cookie')).default;

			var cookieName = 'toast',
				ignoredIds = Cookies.get(cookieName),
				ignoreId = function (id) {
					if (ignoredIds) ignoredIds += ',' + id;
					else ignoredIds = id;

					Cookies.set(cookieName, ignoredIds);
				};

			if (!ignoredIds || !ignoredIds.includes(json.id)) {
				// Set options
				toastr.options.progressBar = true;
				toastr.options.closeButton = true;
				toastr.options.timeOut = 5000;
				toastr.options.extendedTimeOut = 5000;
				toastr.options.showDuration = 0,
					toastr.options.target = 'header',
					toastr.options.iconClasses = { info: 'notification' };
				toastr.options.titleClass = '';
				toastr.options.messageClass = 'date';

				toastr.info('', '<a href=' + json.url + '><strong>' + json.title + '</strong> <span>' + json.text + '</span></a>', {
					onHidden: function () {
						ignoreId(json.id);
					}
				}).on({
					click: function () {
						ignoreId(json.id);
						document.location = json.url;
					}
				});
			}
		});
	}

	// Date picker
	//$('input[type="date"]').each(function () {
	//	var element = $(this);
	//	var label = element.next();

	//	if (element.val()) {
	//		setValue(element, false);
	//	}

	//	element.on('change', function () {
	//		setValue(element);
	//	});

	//	element.on("invalid", function (e) {
	//		e.target.setCustomValidity("U kunt helaas niet bestellen op maandag, dinsdag en woensdag");
	//	});

	//	element.on("input", function (e) {
	//		e.target.setCustomValidity("");
	//	});

	//	function setValue(element, checkIfValid = true) {
	//		var date = new Date(element.val());
	//		if (checkIfValid) {
	//			if (date.getDay() === 1 || date.getDay() === 2 || date.getDay() === 3) {
	//				element.val("");
	//			}
	//		}
	//		label.text(date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear());
	//		label.addClass('has-value');
	//	}
	//});

	// Modal
	$('.modal').each(async function () {
		var Cookies = (await import('js-cookie')).default;

		var modalId = 'modal';
		var cookieName = 'modal',
			ignoredIds = Cookies.get(cookieName),
			ignoreId = function (id) {
				if (ignoredIds) ignoredIds += ',' + id;
				else ignoredIds = id;

				Cookies.set(cookieName, ignoredIds, { expires: 1 });
			};

		if (!ignoredIds || !ignoredIds.includes(modalId)) {
			var modal = $(this);
			var close = modal.find('.modal-close');

			modal.addClass('is-visible');

			close.click(function () {
				modal.removeClass('is-visible');
				ignoreId(modalId);
			});

			modal.find('a.button').click(function () {
				modal.removeClass('is-visible');
				ignoreId(modalId);
			});

			modal.find('.modal-background').click(function () {
				modal.removeClass('is-visible');
				ignoreId(modalId);
			});
		}
	});
});